import React, { Fragment ,useState, useEffect} from "react";
import { Col, Card, Table, Spinner } from "react-bootstrap";
import { Link , useLocation} from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
const CMSPagesList = () => {
    
    const { getRequest , putRequest} = useRequests();
    const [loading, setLoading] = useState(true);
    const [cmsData, setCmsData] = useState([]);
    const location = useLocation();
    const [selectedPage, setSelectedPage] = useState(null);
        
    const [AlertData, setAlertData] = React.useState({
                variant: '',
                message: '',
            });
            const resetAlertData = () => {
                setTimeout(() => {
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: '',
                        message: '',
                    }));
                }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
            };

            // Fetch settings data from the API
                const fetchCmsPages = async () => {
                    setLoading(true);
                    const response = await getRequest("cms-list"); // Replace "site-settings" with your actual API endpoint
                    if (response && response.code === 200) {
                        setCmsData(response.data); // Assuming response.data contains the settings
                    } else {
                        console.error("Failed to fetch cms pages:", response.message);
                        setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: 'Failed to fetch cms pages',
                        }));
                    
                    resetAlertData();
                    }
                    setLoading(false);
                };
            
                useEffect(() => {
                    fetchCmsPages();
                    if (location.state && typeof location.state.message !== 'undefined') {
                        setAlertData((AlertData) => ({
                          ...AlertData,
                          variant: location.state.status,
                          message: location.state.message,
                        }));
                        resetAlertData();
                    }
                }, []);
    return (
        <Fragment>
            <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
                <h2 className="text-black font-w600 mb-0">CMS Page Management</h2>
                {AlertData.message !== "" ? (
                            <Snackbars
                              variant={AlertData.variant}
                              message={AlertData.message}
                            />
                          ) : (
                            ""
                          )}
            </div>
            <Col lg={12}>
                <Card>
                    <Card.Body>
                      {loading ? (
                <div className='text-center'>
                  <Spinner animation='border'variant="primary"  />
                  <p>Loading settings...</p>
                </div>
              ) : 
              (  <Table responsive>
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th style={{ width: "100px" }} className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cmsData.map((item) => (
                                <tr key={item.p_id}>
                                    <td>{item.page_title}</td>
                                    <td className="text-center">
                                   
                                        <Link to={`/cms-page-edit/${item.page_slug}`} className="btn btn-primary btn-xs sharp me-1" title="Edit CMS">
                                            <i className="flaticon-381-edit-1"></i>
                                        </Link>
                                    </td>
                                </tr>))}
                              
                            </tbody>
                        </Table>)}
                    </Card.Body>
                </Card>
            </Col>
        </Fragment>
    );
};

export default CMSPagesList;
